// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".red[data-v-830e3ba6]{color:var(--color-secondary)}.green[data-v-830e3ba6]{color:var(--color-primary)}.orderbook-preview.order-book[data-v-830e3ba6]{padding:10px 20px}.orderbook-preview .order-row[data-v-830e3ba6]{height:20px!important}.orderbook-preview .sell-row span[data-v-830e3ba6]:first-child{color:var(--main-red)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
